import { StyleSheet } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export const getDataLoadErrorPanelStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 24,
      paddingVertical: 32,
    },
    title: {
      fontSize: 18,
      fontWeight: '700',
      color: theme.gray[900],
      textAlign: 'center',
      marginBottom: 8,
    },
    message: {
      fontSize: 14,
      color: theme.gray[600],
      textAlign: 'center',
      marginBottom: 20,
    },
    retryButton: {
      backgroundColor: theme.primary,
      paddingHorizontal: 20,
      paddingVertical: 12,
      borderRadius: 12,
    },
    retryButtonPressed: {
      opacity: 0.85,
    },
    retryButtonHover: {
      opacity: 0.92,
    },
    retryButtonText: {
      color: theme.white,
      fontSize: 15,
      fontWeight: '700',
    },
  })
